import { defineAction } from '~/prix'
import answerSheetListAction from './answerSheetList.action.json' with { type: 'json' }
import { answerSheetObject } from '../answerSheetObject'
import { z } from 'zod'

const answerSheetListDefinition = defineAction({
  ...answerSheetListAction,
  input: z.object({}),
  output: z.object({
    items: z.array(answerSheetObject),
    count: z.number(),
  }),
})

export default answerSheetListDefinition
